// Shared field renderer for configuration components
import React from 'react';
import { Grid, Divider } from '@mui/material';
import { grey } from '@mui/material/colors';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';

// Helper function to format field names
const formatFieldName = (fieldName) => {
  return fieldName
    .replace(/SBQQ__/g, '')
    .replace(/__c/g, '')
    .replace(/([A-Z])/g, ' $1')
    .trim();
};

// Main field renderer function
export const renderFields = (fields, options = {}) => {
  const {
    showAllFields = true,
    allowedFields = null,
    fieldNameFormatter = formatFieldName,
    showDivider = true,
    fieldSpacing = 1,
  } = options;

  if (!fields) {
    return <ArgonTypography variant="caption">No details available.</ArgonTypography>;
  }

  // Get fields to display
  let fieldsToRender = fields;
  if (allowedFields && Array.isArray(allowedFields)) {
    fieldsToRender = Object.fromEntries(Object.entries(fields).filter(([key]) => allowedFields.includes(key)));
  }

  if (Object.keys(fieldsToRender).length === 0) {
    return <ArgonTypography variant="caption">No fields are configured for display.</ArgonTypography>;
  }

  return (
    <ArgonBox>
      {Object.entries(fieldsToRender).map(([key, value]) => (
        <ArgonBox key={key} mb={fieldSpacing} width="100%">
          <Grid container alignItems="center" spacing={0}>
            <Grid item xs={7}>
              <ArgonTypography
                fontSize={12}
                fontWeight="bold"
                color="textSecondary"
                align="left"
                sx={{ wordWrap: 'break-word', color: grey[700] }}
                ml={3}
              >
                {fieldNameFormatter(key)}
              </ArgonTypography>
            </Grid>
            {showDivider && (
              <Grid item xs={1} style={{ textAlign: 'center' }}>
                <Divider orientation="vertical" flexItem />
              </Grid>
            )}
            <Grid item xs={showDivider ? 4 : 5} style={{ textAlign: 'center' }}>
              <ArgonBox
                bgcolor={grey[200]}
                color={grey[700]}
                p={0.8}
                borderRadius="md"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <ArgonTypography
                  fontSize={12}
                  variant="body2"
                  fontWeight="bold"
                  sx={{ wordWrap: 'break-word', width: '100%' }}
                >
                  {value === null || value === undefined ? 'N/A' : String(value)}
                </ArgonTypography>
              </ArgonBox>
            </Grid>
          </Grid>
        </ArgonBox>
      ))}
    </ArgonBox>
  );
};

export default renderFields;

